
import { Apollo, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { ApplicationConfig, inject } from '@angular/core';
import { ApolloCache, ApolloClientOptions, InMemoryCache } from '@apollo/client/core';


const uri = ''; // <-- add the URL of the GraphQL server here
export function apolloOptionsFactory(): ApolloClientOptions<any> {
  const httpLink = inject(HttpLink);
  const blankCache = new InMemoryCache({}).restore({});
  return {
    link: httpLink.create({ uri }),
    cache:  blankCache as unknown as ApolloCache<any>,
  };
}

export const graphqlProvider: ApplicationConfig['providers'] = [
  Apollo,
  {
    provide: APOLLO_OPTIONS,
    useFactory: apolloOptionsFactory,
  },
];
